import React from "react"
import { IconSeeker } from "@ui-seeker/core"
import { AppBulkEditAction, AppDialogCancel } from "@components"
import { autoEuropePricingIdDrawerData, autoEuropePricingIdDrawerErrors, clearAutoEuropePricingIdSignals } from "Pages/AutoEuropeTool/PricingId/@signals"

export default function AutoEuropePricingIdFooter({ onSubmit, isLoading }) {
	return <>
		<AppDialogCancel onClick={clearAutoEuropePricingIdSignals}/>
		<AppBulkEditAction
			loading={isLoading}
			startIcon={<IconSeeker icon="floppy-disk"/>}
			disabled={!Object.values(autoEuropePricingIdDrawerErrors.value).every(a => a)}
			onClick={() => onSubmit(autoEuropePricingIdDrawerData.value)}
		>
			Save
		</AppBulkEditAction>
	</>
}
